import { activeSplitStore } from '../../stores';

export const toggleCheckpoint = (value: number | null) => () => {
  activeSplitStore.setValue(value);
};
